import { shape, string } from 'prop-types';

export default shape({
    CDN: string.isRequired,
    CDN_IMAGE: string.isRequired,
});
